import React from "react";

type CreditsBarProps = {
  used: number;
  total: number;
};

const CreditsBar: React.FC<CreditsBarProps> = ({ used, total }) => {
  const available = Math.max(total - used, 0);

  const percentage =
    total > 0 ? Math.min((available / total) * 100, 100) : 0;

  return (
    <div
      style={{
        width: "260px",
        fontFamily: "Inter, sans-serif",
        marginTop: "15px",
      }}
    >
      {/* Progress bar */}
      <div
        style={{
          height: "6px",
          backgroundColor: "#E5E7EB",
          borderRadius: "999px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(0,212,255,1) 0%, rgba(9,9,121,1) 50%, rgba(2,0,36,1) 100%)",
            borderRadius: "999px",
            transition: "width 0.3s ease",
          }}
        />
      </div>
    </div>
  );
};

export default CreditsBar;
